import { render } from "./FlashNotifications.vue?vue&type=template&id=74f7ddf0"
import script from "./FlashNotifications.vue?vue&type=script&lang=js"
export * from "./FlashNotifications.vue?vue&type=script&lang=js"

import "./FlashNotifications.vue?vue&type=style&index=0&id=74f7ddf0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FlashNotifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74f7ddf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74f7ddf0', __exports__)) {
    api.reload('74f7ddf0', __exports__)
  }
  
  module.hot.accept("./FlashNotifications.vue?vue&type=template&id=74f7ddf0", () => {
    api.rerender('74f7ddf0', render)
  })

}


export default __exports__